import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import moment from "moment";
import Select from "react-select";

const initialFieldValues = {
  serviceTaskId: "00000000-0000-0000-0000-000000000000",
  staffId: "00000000-0000-0000-0000-000000000000",
  clientId: "00000000-0000-0000-0000-000000000000",
  categoryId: "00000000-0000-0000-0000-000000000000",
  serviceName: "",
  cycle: "",
  month: new Date(),
  status: "",
};

export default function ServiceModal({ show, onClose, editData, refreshData }) {
  const [staffs, setStaffs] = useState([]);
  const [clients, setClients] = useState([]);
  const [categories, setCategories] = useState([]);
  const [services, setServices] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [btnSubmit, setBtnSubmit] = useState(true);
  const [userCompanyId, setUserCompanyId] = useState("");
  const userId = localStorage.getItem("userId");

  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };

  useEffect(() => {
    if (editData) {
      // When editData is provided, populate the form with its values
      setValues({
        serviceTaskId: editData.serviceTaskId,
        staffId: editData.staffId || "00000000-0000-0000-0000-000000000000",
        clientId: editData.clientId,
        categoryId: editData.categoryId,
        serviceName: editData.serviceName,
        cycle: editData.cycle,
        month: new Date(editData.month),
        status: editData.status,
      });

      // Fetch services for the selected category
      if (editData.categoryId) {
        axios
          .get(
            config.APIACTIVATEURL +
              config.GETSERVICESBYCATEGORY +
              "/" +
              editData.categoryId,
            headerconfig
          )
          .then((response) => {
            setServices(response.data);
          })
          .catch((error) => {
            handleError("Failed to fetch services");
            setServices([]);
          });
      }
    } else {
      // Reset to initial values when creating a new task
      setValues(initialFieldValues);
      setServices([]);
    }
  }, [editData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleCategoryChange = async (e) => {
    const categoryId = e.target.value;
    setValues({
      ...values,
      categoryId,
      serviceName: "",
      cycle: "",
    });

    try {
      const response = await axios.get(
        config.APIACTIVATEURL + config.GETSERVICESBYCATEGORY + "/" + categoryId,
        headerconfig
      );
      setServices(response.data);
    } catch (error) {
      handleError("Failed to fetch services");
      setServices([]);
    }
  };

  const handleServiceChange = (e) => {
    const selectedService = services.find(
      (s) => s.serviceName === e.target.value
    );

    if (selectedService) {
      setValues({
        ...values,
        serviceName: selectedService.serviceName,
        cycle: selectedService.cycle,
      });
    }
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setErrors({});
    setServices([]);
  };

  const validate = () => {
    let temp = {};
    temp.clientId = values.clientId !== "00000000-0000-0000-0000-000000000000";
    temp.categoryId =
      values.categoryId !== "00000000-0000-0000-0000-000000000000";
    temp.serviceName = values.serviceName !== "";

    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      setBtnSubmit(false);
      const formData = new FormData();
      formData.append("serviceTaskId", values.serviceTaskId);
      formData.append("serviceName", values.serviceName);
      formData.append("cycle", values.cycle);
      formData.append("clientId", values.clientId);
      formData.append("categoryId", values.categoryId);
      formData.append("staffId", values.staffId);
      formData.append("month", moment(values.month).format("YYYY-MM"));
      formData.append("companyId", userCompanyId);
      formData.append("status", values.status);

      addOrEdit(formData);
    }
  };

  const applicationAPI = () => {
    return {
      create: (newrecord) =>
        axios.post(
          config.APIACTIVATEURL + config.CREATESERVICETASKBYSTAFF,
          newrecord,
          {
            ...headerconfig,
          }
        ),
      update: (updateRecord) =>
        axios.put(
          config.APIACTIVATEURL + config.UPDATESERVICETASK,
          updateRecord,
          {
            ...headerconfig,
          }
        ),
    };
  };

  const addOrEdit = (formData) => {
    if (
      formData.get("serviceTaskId") === "00000000-0000-0000-0000-000000000000"
    ) {
      applicationAPI()
        .create(formData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            handleSuccess(res.data.data);
            resetForm();
            setBtnSubmit(true);
            onClose();
            if (refreshData) refreshData();
          } else {
            handleError(res.data.data);
            setBtnSubmit(true);
          }
        })
        .catch(function (error) {
          handleError("Error in saving data");
          setBtnSubmit(true);
        });
    } else {
      applicationAPI()
        .update(formData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            handleSuccess("Record Updated");
            resetForm();
            onClose();
            if (refreshData) refreshData();
          } else {
            handleError(res.data.message);
            setBtnSubmit(true);
          }
        })
        .catch((err) => {
          handleError("Error in updating data");
          setBtnSubmit(true);
        });
    }
  };

  const GetStaffs = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETALLSTAFFS + "?userId=" + userId, {
        ...headerconfig,
      })
      .then((response) => {
        setStaffs(response.data.data);
      });
  };

  const GetClients = () => {
    axios
      .get(
        config.APIACTIVATEURL + config.GETALLCLIENTS + "?userId=" + userId,
        headerconfig
      )
      .then((response) => {
        setClients(response.data.data);
      });
  };

  const GetCategories = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETTOPLEVELCATEGORIES, headerconfig)
      .then((response) => {
        setCategories(response.data.data);
      });
  };

  const GetUserData = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETUSERBYID + "/" + userId, {
        ...headerconfig,
      })
      .then((res) => {
        if (res.data.statusCode === 200) {
          setUserCompanyId(res.data.data.companyId);
        }
      });
  };

  const applyErrorClass = (field) =>
    field in errors && !errors[field] ? " form-control-danger" : "";

  useEffect(() => {
    GetStaffs();
    GetCategories();
    GetClients();
    GetUserData();
  }, []);

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{editData ? "Edit Task" : "Create Task"}</Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-6">
              <div className="mb-3">
                <label htmlFor="clientId" className="form-label">
                  Client
                </label>
                <Select
                  name="clientId"
                  value={
                    clients.find((c) => c.clientId === values.clientId)
                      ? {
                          value: values.clientId,
                          label:
                            clients.find((c) => c.clientId === values.clientId)
                              ?.clientName || "All",
                        }
                      : null
                  }
                  onChange={(selectedOption) =>
                    setValues({
                      ...values,
                      clientId: selectedOption
                        ? selectedOption.value
                        : "00000000-0000-0000-0000-000000000000",
                    })
                  }
                  options={[
                    {
                      value: "00000000-0000-0000-0000-000000000000",
                      label: "All",
                    },
                    ...clients.map((c) => ({
                      value: c.clientId,
                      label: c.clientName,
                    })),
                  ]}
                  isSearchable
                  placeholder="Select Client"
                />
                {errors.clientId === false && (
                  <div className="validationerror">Please select client</div>
                )}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-3">
                <label htmlFor="categoryId" className="form-label">
                  Category
                </label>
                <select
                  name="categoryId"
                  value={values.categoryId}
                  onChange={handleCategoryChange}
                  className={"form-select " + applyErrorClass("categoryId")}
                >
                  <option value="00000000-0000-0000-0000-000000000000">
                    Select Category
                  </option>
                  {categories.map((c) => (
                    <option key={c.categoryId} value={c.categoryId}>
                      {c.categoryName}
                    </option>
                  ))}
                </select>
                {errors.categoryId === false && (
                  <div className="validationerror">Please select category</div>
                )}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-3">
                <label htmlFor="serviceName" className="form-label">
                  Service
                </label>
                <select
                  name="serviceName"
                  value={values.serviceName}
                  onChange={handleServiceChange}
                  className={"form-select " + applyErrorClass("serviceName")}
                >
                  <option value="">Select Service</option>
                  {services.map((service) => (
                    <option
                      key={service.systemTaskId}
                      value={service.serviceName}
                    >
                      {service.serviceName} ({service.cycle})
                    </option>
                  ))}
                </select>
                {errors.serviceName === false && (
                  <div className="validationerror">Please select service</div>
                )}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-3">
                <label htmlFor="month" className="form-label">
                  Service Month
                </label>
                <Flatpickr
                  value={values.month}
                  className="form-control"
                  options={{
                    dateFormat: "Y-m",
                    plugins: [
                      new monthSelectPlugin({
                        shorthand: true,
                        dateFormat: "M-Y",
                        theme: "light",
                      }),
                    ],
                  }}
                  onChange={(date) => {
                    setValues({
                      ...values,
                      month: date[0],
                    });
                  }}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-3">
                <label>Staff</label>
                <select
                  name="staffId"
                  value={values.staffId}
                  onChange={handleInputChange}
                  className="form-select"
                >
                  <option value="00000000-0000-0000-0000-000000000000">
                    Select Staff
                  </option>
                  {staffs.map((s) => (
                    <option key={s.staffId} value={s.staffId}>
                      {s.staffName}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="mb-3">
                <label htmlFor="status" className="form-label">
                  Status
                </label>
                <select
                  name="status"
                  value={values.status}
                  onChange={handleInputChange}
                  className="form-select"
                >
                  <option value="">Select Status</option>
                  <option value="COMPLETED">COMPLETED</option>
                  <option value="PENDING">PENDING</option>
                </select>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="danger"
            onClick={() => {
              resetForm();
              onClose();
            }}
          >
            Cancel
          </Button>
          {btnSubmit ? (
            <Button variant="primary" type="submit">
              {editData ? "Update" : "Generate"}
            </Button>
          ) : (
            <Button variant="primary" type="submit" disabled>
              Please wait...
            </Button>
          )}
        </Modal.Footer>
      </form>
    </Modal>
  );
}
